import React from 'react';
import { useTranslation } from 'react-i18next';

function WelcomeGuide({ onPlanMeals, onStockPantry }) {
  const { t } = useTranslation();

  return (
    <div className="welcome-guide">
      <h2 className="welcome-title">{t('welcome.title')}</h2>
      <p className="welcome-subtitle">{t('welcome.subtitle')}</p>
      <div className="welcome-paths">
        <button className="welcome-path" onClick={onPlanMeals}>
          <span className="welcome-path-icon">🍽</span>
          <span className="welcome-path-label">{t('welcome.planMeals')}</span>
          <span className="welcome-path-desc">{t('welcome.planMealsDesc')}</span>
        </button>
        <button className="welcome-path" onClick={onStockPantry}>
          <span className="welcome-path-icon">🥬</span>
          <span className="welcome-path-label">{t('welcome.stockPantry')}</span>
          <span className="welcome-path-desc">{t('welcome.stockPantryDesc')}</span>
        </button>
      </div>
      <p className="welcome-hint">{t('welcome.hint')}</p>
    </div>
  );
}

export default WelcomeGuide;
